<div *ngIf="tag" class="div__tag" [ngClass]="{ 'tag--destaque': destaque }">
  <img
    class="pontos__icone"
    *ngIf="exibirIcone()"
    [ngClass]="{ pontos__icone_mobile: pageIndex }"
    src="assets/images/icons/cacau_moeda.png"
  />
  <p class="lbl__tag" [ngClass]="{ lbl__tag__mobile: pageIndex }">
    {{ tag }}
  </p>
</div>
